import React from 'react';
import { FiCamera } from 'react-icons/fi';

export default function FarmbotCameraIcon() {
  return <FiCamera size={18} />;
}
